import { HotelReserveCancellationPoliciesPropertiesTypes } from "@website/accommodation-ui/hotel-reserve-cancellation-policies/hotel-reserve-cancellation-policies.types";
import { MaterialIcon } from "@website/icons/material";
import { CollapsibleText } from "@website/ui/collapsible-text";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = ({
  cancellationRules,
  hotelRules,
  title,
  direction,
  cancellationRuleRenderNewLines
}: HotelReserveCancellationPoliciesPropertiesTypes) => {
  const router = useRouter();

  if (!cancellationRules?.length && !hotelRules?.length) return null;

  return (
    <div className="flex flex-col gap-10">
      {(hotelRules?.length ?? 0) > 0 && (
        <div className="text-body-2 text-on-surface-high-emphasis">
          <CollapsibleText
            ariaLabel="rules"
            collapsedClassName="h-[100px]"
            content={hotelRules?.map((item) => {
              const html = numberConvert(item, {
                locale: router.locale
              }).replaceAll("&nbsp;", "");
              return (
                <div
                  className="text-body-2 text-on-surface-high-emphasis flex flex-row items-start gap-1 pb-1"
                  hidden={!html}
                  key={html}
                >
                  <div className="text-on-surface-medium-emphasis">
                    <MaterialIcon name="check" />
                  </div>
                  <span dangerouslySetInnerHTML={{ __html: `${html}.` }} />
                </div>
              );
            })}
            direction={direction}
            lessText="بستن"
            lessTextIcon={<MaterialIcon name="arrow_drop_up" />}
            moreText="مشاهده بیشتر"
            moreTextIcon={<MaterialIcon name="arrow_drop_down" />}
            title={title || ""}
            titleStyle="text-subtitle-1 md:text-headline-6 mb-3 block text-right"
          />
        </div>
      )}
      {Boolean(cancellationRules?.length) && (
        <div className="text-body-2 text-on-surface-high-emphasis">
          <CollapsibleText
            className="flex flex-col gap-1"
            ariaLabel="cancellation-rules"
            collapsedClassName="h-[48px]"
            content={cancellationRules?.map((item) => {
              const html = numberConvert(item, {
                locale: router.locale
              })
                .replaceAll("&nbsp;", "")
                .trimStart()
                .replace("-", "");
              return (
                <div
                  className="text-body-2 text-on-surface-high-emphasis flex flex-row items-center gap-1 pb-1"
                  hidden={!html}
                  key={html}
                >
                  <div className="text-on-surface-medium-emphasis">
                    <MaterialIcon name="check" />
                  </div>
                  <span
                    className={`${
                      cancellationRuleRenderNewLines
                        ? "whitespace-pre-wrap"
                        : ""
                    }`}
                    dangerouslySetInnerHTML={{ __html: `${html}.` }}
                  />
                </div>
              );
            })}
            lessText="بستن"
            lessTextIcon={<MaterialIcon name="arrow_drop_up" />}
            moreText="مشاهده بیشتر"
            moreTextIcon={<MaterialIcon name="arrow_drop_down" />}
            title="قوانین کنسلی"
            titleStyle="text-subtitle-1 md:text-headline-6 mb-3 block text-right"
          />
        </div>
      )}
    </div>
  );
};
export const HotelReserveCancellationPolicies = memo(Component, deepCompare);
